// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__37LiC","modalFooterButton":"ModalNotes_modalFooterButton__3gJL1"};